<!--头部信息-->
<template>
  <div class="TopBar">
    <div class="title">
      <img class="logo" :src="logo_url" alt="logo">
      <h1 class="text">{{$store.state.currentServerInfo.title}}</h1>
    </div>
    <div class="HeadBarRight">
      <el-dropdown @command="handleCommand">
        <div class="el-dropdown-link flex">
          <img src="../../../../static/images/avater.png" alt=""><em>{{$store.state.eUserInfo.user_name}}</em>
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="map" v-if="isfunMap">
            <i class="el-icon-location-outline"></i>
            仪表盘
          </el-dropdown-item> -->
          <el-dropdown-item command="modifyPassword" :divided="isfunMap">
            <i class="ico ico-my"></i>
            修改密码
          </el-dropdown-item>
          <el-dropdown-item command="loginSetting" v-if="isShow == true">
            <i class="ico ico-settings"></i>
            基本设置
          </el-dropdown-item>
          <el-dropdown-item command="loginOut" divided>
            <i class="ico ico-login"></i>
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> 
  </div>
</template>

<script>
  import { updataBreadCrumb,localUserInfo, setLogoTitle } from "../../../../static/js/utility/utility.js"

  export default {
    name: 'CTopBar',
    data() {
      return {
        isfunMap:false,
        isShow:false,
        logo_url: ''
      }
    },

    mounted() {
      this.isfunMap = this.$store.state.isfunMap
      let is_admin = localUserInfo.getItem().is_admin
      if(this.isfunMap == true || is_admin == '1'){
        this.isShow = true
      }
      this.logo_url =  (localUserInfo.getItem().logo_url != '') 
        ? (localUserInfo.getItem().logo_url) 
        : ('../../../..' + this.$store.state.currentServerInfo.logoUrl2);
    },

    methods: {
      // 点击下拉菜单list，点击执行相关操作
      handleCommand(command) {
        // console.log('command', command)
        if (command === 'map') {
          this.$router.push({
            path: '/CMap'
          })
        } else if (command === 'loginOut') {
          // 退出登录,清空缓存数据,跳转登录页
          localStorage.clear()
          sessionStorage.clear()
          setLogoTitle()
          this.$router.push({
            path: '/'
          })
        } else if(command === 'loginSetting'){
          let navBarActive = [{function_tab: 'LoginSetting', function_name: '基本设置'}]
          // 更新面包屑内容
          updataBreadCrumb(2, navBarActive)
          // 基本设置
          this.$router.push({
            path: '/CLoginSetting'
          })
        } else {
          let navBarActive = [{function_tab: 'ModifyPassword', function_name: '修改密码'}]
          // 更新面包屑内容
          updataBreadCrumb(2, navBarActive)
          // 修改密码
          this.$router.push({
            path: '/CModifyPassword'
          })
        }
      }
    },

    watch: {
      '$store.state.isfunMap':function(newVal){
        this.isfunMap = newVal
      },
    }

  }
</script>

<style lang="scss" scoped>
$TopBarHeight: 90px;
.TopBar {
  height: $TopBarHeight;
  line-height: $TopBarHeight;
  // background-color: #fff;
  background: linear-gradient(to bottom right, #008ef2 , #096bf1);
  // box-shadow: 0 1px 4px rgba(0,21,41,.08);
  position: relative;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 70px 0 30px;
  box-sizing: border-box;
  .flex{
    height: 60px;
    display: flex;
    align-items: center;
  }
  .title{
    display: flex;
    align-items: center;
    .logo{
      width: 51px;
      img{ width: 100%; }
    }
    .text{
      font-size: 30px;
      color: #fff;
      margin-left: 15px;
    }
  }
  .switchIcon {
    float: left;
    height: $TopBarHeight;
    font-size: 20px;
    cursor: pointer;
    transition: all .3s,padding 0s;
    padding: 0 24px;
    i{
      font-size: 20px;
      line-height: $TopBarHeight;
    }
  }
  .HeadBarRight{
    height: 60px;
    display: flex;
    img{
      width: 60px;
      height: 60px;
    }
    em {
      font-size: 22px;
      color: #fff;
      text-decoration: underline;
      margin: 0 14px;
    }
  }
}
// 下拉菜单
.el-dropdown-menu {
  min-width: 124px;
  padding: 6px 0;
  .el-dropdown-menu__item {
    line-height: 35px;
  }
  // .el-dropdown-menu__item:nth-child(2){
  //   border-bottom: 1px solid #ebeef5;
  // }
  .el-dropdown-menu__item--divided {
    // margin-top: 4px;
    // border-top: none;
  }
  .el-dropdown-menu__item--divided:before {
    // height: 0;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Page/Layout/CTopBar.vue